import { render, staticRenderFns } from "./ClaimConfirmationModal.vue?vue&type=template&id=1af66530&scoped=true&"
import script from "./ClaimConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ClaimConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimConfirmationModal.vue?vue&type=style&index=0&id=1af66530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af66530",
  null
  
)

export default component.exports